<script>
    import ImgLazy from './ImgLazy.vue';

    export default {
        components: {
            'img-lazy': ImgLazy,
        },
        props: {
            item: Object,
            mediaUrl: String,
            modelSelectorUrl: String,
            uploadUrl: String,
            mediaImportUrl: String,
            enableUpload: Boolean,
            uploadDisk: String,
            timestamp: String,
            allowDirectDownload: Boolean,
        },
        data() {
            return {
                token: Scoop.csrfToken,
                hovered: false,
            }
        },
        watch: {
            enableUpload(value) {
                this.$nextTick(() => {
                    this.dropzoneInit(value);
                });
            },
        },
        computed: {
            itemSelected() {
                return _.indexOf(this.selectedMediaIds, this.item.id) !== -1;
            },
            selectedMediaIds: {
                get: function () {
                    return scoopOS.getSelected('medias');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('medias', newValue);
                }
            },
            previewSrc(){
                if (this.hasFormat('SCOOP_OS_PREVIEW_VIDEO') && this.hovered){
                    return this.getFormat('SCOOP_OS_PREVIEW_VIDEO');
                }

                return this.item.previewImageUrl + '&t=' + this.timestamp;
            }
        },
        mounted() {
            this.$parent.$on('toggle', (medias) => {
                if (_.indexOf(medias, this.item.id) !== -1) {
                    this.toogleSelection();
                }
            });
        },
        methods: {
            dropzoneInit(enabled) {
                let el = '#image-upload-' + this.item.id;

                if (enabled) {
                    new Dropzone(el, {
                        vm: this,
                        clickable: false,
                        maxFiles: 1,
                        accept: (file, done) => {
                            if (file.name.indexOf(this.item.type) === -1) {
                                toastr.error('The extension <strong>.' + this.item.type + '</strong> does not match', 'Replace failed');
                                done('error');
                            } else {
                                done();
                            }
                        },
                        init: function () {
                            this.on("success", function () {
                                let vm = this.options.vm;

                                toastr.success(
                                    vm.item.filename + '<br><br><strong>Go to media import</strong>',
                                    'File succesfully uploaded',
                                    {
                                        onclick: function () {
                                            window.location.href = vm.mediaImportUrl;
                                        }
                                    });
                            });

                            this.on("complete", function () {
                                this.options.vm.$emit('reset');
                                this.removeAllFiles(true);
                            });
                        }
                    });
                }
            },
            toogleSelection() {
                scoopOS.toggle('medias', this.item.id);
            },
            hasFormat(format){
                return _.indexOf(_.map(this.item.formats, 'format'), format) !== -1;
            },
            getFormat(formatName){
                let format = _.first(_.filter(this.item.formats, {'format': formatName}));

                return format.url;
            }
        },
    }
</script>

<template>
    <div class="upload-media-file file-box" :data-media-upload-id="item.id">
        <div class="file" :class="{ selected: itemSelected }" @mouseenter="hovered = true" @mouseleave="hovered = false">
            <a :title="__('scoop-os.media.show_media_file_details')" :href="mediaUrl + item.id + '/edit'">
                <div class="image">
                    <img-lazy class="img-responsive" :src="previewSrc"></img-lazy>
                    <slot name="media-file-icons"></slot>

                    <form method="post" :action="uploadUrl"
                          accept-charset="utf-8" enctype="multipart/form-data"
                          class="dropzone" :id="'image-upload-' + item.id"
                          v-if="enableUpload"
                    >
                        <input type="hidden" name="uploadDisk" :value="uploadDisk"/>
                        <input type="hidden" name="frmMediaDirectory" :value="item.directory"/>
                        <input type="hidden" name="frmMediaIndex" :value="item.index_id"/>
                        <input type="hidden" name="_token" :value="token"/>
                    </form>
                </div>
            </a>
            <media-direct-download :media="item" v-if="allowDirectDownload">
                <button class="btn btn-white btn-xs" style="position: absolute; right: 3px; top: 3px;">
                    <i class="fa fa-download"></i>
                </button>
            </media-direct-download>
            <a @click="toogleSelection()">
                <div class="file-name ellipsis">
                <span v-if="item.filename.length > 22" data-toggle="tooltip" data-placement="bottom" title=""
                      :data-original-title="item.filenameAltWrap">{{ item.filenameShortened }}</span>
                    <span v-else>{{ item.filenameShortened }}</span>
                    <small :title="__('scoop-os.labels.last_updated') + ': ' + item.updated_at">
                        {{ __('scoop-os.labels.imported') }}: {{ item.created_at }}
                    </small>
                </div>
            </a>
        </div>
    </div>
</template>
